import { render } from "./DashboardComponentNew.vue?vue&type=template&id=9948a722"
import script from "./DashboardComponentNew.vue?vue&type=script&lang=js"
export * from "./DashboardComponentNew.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__